import { render, staticRenderFns } from "./RecurringRemarkModal.vue?vue&type=template&id=19fbb242"
import script from "./RecurringRemarkModal.vue?vue&type=script&lang=js"
export * from "./RecurringRemarkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19fbb242')) {
      api.createRecord('19fbb242', component.options)
    } else {
      api.reload('19fbb242', component.options)
    }
    module.hot.accept("./RecurringRemarkModal.vue?vue&type=template&id=19fbb242", function () {
      api.rerender('19fbb242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recurringremarks/RecurringRemarkModal.vue"
export default component.exports